import CloseIcon from '@mui/icons-material/Close';
import { DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';
import { IStripeClientSecretPayload, getStripeClientSecret } from 'wisestep-api';
import { Spinner, WsDialog } from 'wisestep-base';

import { useTotalInvitesCall } from '../../users/helper/hooks';
import { IPaymentInfo } from '../types/IPaymentInfo';

import ManagePlan from './ManagePlan';
import PaymentCalculation from './PaymentCalculation';
import PaymentContext from './PaymentContext';
import RazorPayManagePlan from './RazorPayManagePlan';
import RazorpayPlanValidator from './RazorPayPlanValidator';

const PaymentModal = ({
  open,
  onClose,
  plan,
}: {
  open: boolean;
  onClose: () => void;
  plan: IPaymentInfo;
}) => {
  const [maxInvites] = useTotalInvitesCall();
  const [openDialog, setOpenDialog] = useState(open);
  const [secretKey, setSecretKey] = useState<string | null>(null);

  useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const handleClose = () => {
    setOpenDialog(false);
    onClose();
  };

  const onUserAcceptance = async (payload: IStripeClientSecretPayload) => {
    const req = await getStripeClientSecret(payload);
    setSecretKey(req.data);
  };

  return (
    <WsDialog size="medium" openDialog={openDialog} onClose={handleClose}>
      <DialogContent>
        <CloseIcon sx={{ float: 'right' }} onClick={handleClose} />
        {secretKey ? (
          <PaymentContext secretKey={secretKey} />
        ) : (
          <>
            {plan.manageUsers ? (
              <>
                {maxInvites >= 0 ? (
                  <>
                    {plan.manual ? (
                      <RazorPayManagePlan plan={plan} handleClose={handleClose} />
                    ) : (
                      <ManagePlan plan={plan} user={maxInvites} handleClose={handleClose} />
                    )}
                  </>
                ) : (
                  <Spinner />
                )}
              </>
            ) : (
              <>
                {plan.manual ? (
                  <RazorpayPlanValidator plan={plan} />
                ) : (
                  <PaymentCalculation plan={plan} onUserAcceptance={onUserAcceptance} />
                )}
              </>
            )}
          </>
        )}
      </DialogContent>
    </WsDialog>
  );
};

export default PaymentModal;
